import {Component, Inject, Input, OnInit} from '@angular/core';
import {AccountUploadModel} from "../../../../models/requests/account/account-upload.model";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {ApiService} from "../../../../services/api.service";
import {SweetalertService} from "../../../../services/sweetalert.service";
import {AccountHomeService} from "../account-home.service";
import {USER_PERMISSIONS} from "../../../../enums/user-permissions.enum";
import {ErrorService} from '../../../../services/error.service';
import {AuthService} from '../../../../services/auth.service';

@Component({
  selector: 'app-account-upload',
  templateUrl: './account-upload.component.html',
  styleUrls: ['./account-upload.component.scss']
})
export class AccountUploadComponent implements OnInit {
  @Input() public account: AccountUploadModel;
  public user;
  public isWaiting = false;
  public password: string;
  public repeatPassword: string;
  public USER_PERMISSIONS: typeof USER_PERMISSIONS = USER_PERMISSIONS;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialog,
    private apiService: ApiService,
    private sweetalertService: SweetalertService,
    private errorService: ErrorService,
    private accountHomeService: AccountHomeService,
  ) {
  }

  ngOnInit(): void {
  }

  public togglePermissions(permission) {
    if (this.account.hasPermissions.includes(permission)) {
      this.account.hasPermissions.splice(this.account.hasPermissions.indexOf(permission), 1);
    } else {
      this.account.hasPermissions.push(permission);
    }
  }

  public onFormSubmit() {
    let requestAccount: AccountUploadModel = {};

    if (this.password === this.repeatPassword && this.password) {
      requestAccount.password = this.password;
    }

    requestAccount.hasPermissions = this.account.hasPermissions;

    this.apiService.updateUser(this.account.id, requestAccount).subscribe((response: any) => {
      this.sweetalertService.success();
      this.accountHomeService.refreshUsersList();
      this.dialogRef.closeAll();
    }, error => {
      this.errorService.handleError(error);
    });
  }
}
